export const SowDataActions = {
  quotes: 'Quotes',
  contracts: 'Contracts',
  orders: 'Orders',
};
